import * as React from "react";

import {HeaderWrapper, StyledCollapse, StyledPanel} from "./styles";

const CollapseIcon = (props: any) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={17}
        height={10}
        fill="none"
        {...props}
    >
        <path
            fill="#000"
            d="M8.504 6.66 15.115.125a.425.425 0 0 1 .6 0l1.161 1.17a.425.425 0 0 1 .124.302.434.434 0 0 1-.124.303L8.803 9.882a.395.395 0 0 1-.307.117.41.41 0 0 1-.308-.117L.124 1.91A.425.425 0 0 1 0 1.608a.435.435 0 0 1 .124-.303l1.16-1.17a.425.425 0 0 1 .6 0l6.62 6.525Z"
        />
    </svg>
)

export const Header = ({children, icon}: { children: React.ReactNode, icon: React.ReactNode }) => (
    <HeaderWrapper>
        <div className="header-content">
            {icon}
            {children}
        </div>
        <CollapseIcon className="collapse-icon"/>
    </HeaderWrapper>
)

export interface IPanelProps {
    key: any

    children: React.ReactNode

    header: React.ReactNode

    headerIcon: React.ReactNode
}

export function Panel({children, header, headerIcon, key, ...rest}: IPanelProps) {
    // @ts-ignore
    return <StyledPanel
        {...rest}
        header={<Header icon={headerIcon}>{header}</Header>}
        key={key}
        showArrow={false}
    >
        {children}
    </StyledPanel>
}


export function Collapse({children}: { children: React.ReactNode }) {
    return <>
        {/*// @ts-ignore*/}
        <StyledCollapse accordion>
            {children}
        </StyledCollapse>
    </>
}

export function CollapsePanel(props: IPanelProps) {
    const {children, header, headerIcon, key} = props

    return <>
        <Collapse>
            <Panel header={header} headerIcon={headerIcon} key={key}>
                {children}
            </Panel>
        </Collapse>
    </>
}
